import { render, staticRenderFns } from "./editprintingForm.vue?vue&type=template&id=5458e85a&"
import script from "./editprintingForm.vue?vue&type=script&lang=js&"
export * from "./editprintingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editprintingForm.vue"
export default component.exports